// Oct 9 2026 · Karine ask — photo-realistic thumbnail per Square category so
// clients recognise "Botox / Fillers / Skin Boosters…" at a glance. Images live
// in /public/menu-thumbs (240×240 jpg, warm-marble set). Matching is by
// keyword on the Square category name so new/renamed categories still map.
const RULES = [
  [/promo|member|offer|special/i, "promos"],
  [/\bicon\b/i, "icon-cynosure"],
  [/éminence|eminence/i, "eminence-facials"],
  [/neuromod|botox|dysport|nuceiva|xeomin|tox\b/i, "botox"],
  [/sculptra|radiesse|biostim|collagen stim/i, "sculptra"],
  [/filler|lip|rhino|jaw|chin|cheek/i, "fillers"],
  [/prp|platelet|vampire/i, "prp"],
  [/exosome|booster|skinvive|redensity|profhilo|regen/i, "exosomes"],
  [/rf\b|radio ?frequency|potenza|morpheus/i, "rf-microneedling"],
  [/micro ?needl|dermapen|skinpen/i, "microneedling"],
  [/hair removal|laser hair|hair laser/i, "laser-hair"],
  [/genesis/i, "laser-genesis"],
  [/ipl|photofacial|photo facial|bbl/i, "ipl"],
  [/hydra|facial|dermaplan|lymphatic/i, "hydrafacial"],
  [/peel/i, "chemical-peel"],
  [/lesion|spot|vein|tag|angioma|mole/i, "lesion-removal"],
  [/tighten|rejuven|tempsure|thermage|firm/i, "skin-tightening"],
  [/consult|assessment|follow/i, "consultations"],
  [/laser/i, "laser-genesis"],
];

export function menuThumbFor(categoryName) {
  const name = String(categoryName || "");
  for (const [re, key] of RULES) if (re.test(name)) return `/menu-thumbs/${key}.jpg`;
  return "/menu-thumbs/default.jpg";
}

// Client-facing one-liners (what it is · brands we carry) — shown under the
// category name in the booking flow so clients recognise the treatment fast.
const BLURBS = {
  "promos": { en: "Limited-time member pricing on our most-loved treatments.", fr: "Prix membres à durée limitée sur nos soins les plus populaires." },
  "icon-cynosure": { en: "NEW Cynosure Icon MaxG IPL with Tanya · Ottawa — redness, vessels, sun spots. Fixed prices from $99.", fr: "NOUVEAU IPL Icon MaxG avec Tanya · Ottawa — rougeurs, vaisseaux, taches. Prix fixes dès 99 $." },
  "botox": { en: "Botox · Nuceiva · Dysport — smooths lines, lifts brows, prevents wrinkles.", fr: "Botox · Nuceiva · Dysport — lisse les rides, rehausse les sourcils, prévient." },
  "sculptra": { en: "Collagen stimulator — gradual, natural volume & firmness over months.", fr: "Stimulateur de collagène — volume et fermeté naturels, progressifs." },
  "fillers": { en: "Teoxane hyaluronic filler — lips, cheeks, jawline, under-eyes, nose.", fr: "Acide hyaluronique Teoxane — lèvres, joues, mâchoire, cernes, nez." },
  "prp": { en: "Your own platelet-rich plasma — under-eyes, skin quality, hair.", fr: "Votre propre plasma riche en plaquettes — cernes, qualité de peau, cheveux." },
  "exosomes": { en: "Redensity 1 & exosomes — deep hydration and glow from within.", fr: "Redensity 1 et exosomes — hydratation profonde et éclat de l'intérieur." },
  "rf-microneedling": { en: "Radiofrequency + microneedling — tightens, smooths scars & texture.", fr: "Radiofréquence + microneedling — raffermit, lisse cicatrices et texture." },
  "microneedling": { en: "SkinPen microneedling — collagen boost for pores, scars, fine lines.", fr: "Microneedling SkinPen — collagène pour pores, cicatrices, ridules." },
  "laser-hair": { en: "Diode laser — permanent hair reduction, any area, men & women.", fr: "Laser diode — réduction permanente des poils, toutes zones." },
  "laser-genesis": { en: "Gentle Nd:YAG laser — redness, pores, glow. No downtime.", fr: "Laser Nd:YAG doux — rougeurs, pores, éclat. Aucun arrêt." },
  "ipl": { en: "Intense pulsed light — sun spots, redness, uneven tone.", fr: "Lumière pulsée — taches solaires, rougeurs, teint inégal." },
  "eminence-facials": { en: "Éminence organic facials — 24 facials, body rituals & add-ons, from $99.", fr: "Soins biologiques Éminence — 24 soins, rituels corps et ajouts, dès 99 $." },
  "hydrafacial": { en: "HydraFacial & facials — cleanse, exfoliate, hydrate in one visit.", fr: "HydraFacial et soins du visage — nettoie, exfolie, hydrate en une visite." },
  "chemical-peel": { en: "Medical-grade peels — resurface for brighter, smoother skin.", fr: "Peelings médicaux — une peau plus lumineuse et plus lisse." },
  "lesion-removal": { en: "Laser removal of skin tags, spots, veins & small lesions.", fr: "Retrait au laser des acrochordons, taches, veines et petites lésions." },
  "skin-tightening": { en: "Radiofrequency tightening — jawline, neck, body.", fr: "Raffermissement par radiofréquence — mâchoire, cou, corps." },
  "consultations": { en: "Free or virtual consult — a plan made for your face and budget.", fr: "Consultation gratuite ou virtuelle — un plan pour votre visage et votre budget." },
  "default": { en: "Ask us — we'll match you with the right treatment.", fr: "Demandez-nous — nous trouverons le bon soin pour vous." },
};

export function menuCategoryInfo(categoryName, lang = "en") {
  const src = menuThumbFor(categoryName);
  const key = src.split("/").pop().replace(".jpg", "");
  const b = BLURBS[key] || BLURBS.default;
  return { src, key, blurb: b[lang === "fr" ? "fr" : "en"] };
}

export function MenuThumb({ category, size = 56, className = "", testId }) {
  return (
    <img
      src={menuThumbFor(category)}
      alt=""
      width={size}
      height={size}
      loading="lazy"
      decoding="async"
      className={`rounded-full object-cover shrink-0 ${className}`}
      style={{ width: size, height: size, boxShadow: "0 2px 10px -3px rgba(60,40,20,0.35)", border: "2px solid rgba(201,163,90,0.55)" }}
      data-testid={testId}
    />
  );
}
